<template>
  <select :class="cclass" :value="value.regionId" @change="onChangeRegion">
    <option :value="0" selected>Select</option>
    <option v-for="region in regions" :key="region.id" :value="region.id">
      {{ region.title }}
    </option>
  </select>
</template>

<script>
export default {
  props: ["value", "cclass", "regions"],
  methods: {
    onChangeRegion(event) {
      // eslint-disable-next-line no-console
      console.log(event.target.value);
      const region = this.regions.find((r) => r.id == event.target.value);
      // eslint-disable-next-line no-console
      console.log(region, event.target.value);
      if (region) {
        const newRegion = { ...this.value };
        newRegion.regionId = region.id;
        newRegion.regionCode = region.short;
        newRegion.region = region.title;
        // eslint-disable-next-line no-console
        console.log(newRegion);
        this.$emit("input", newRegion);
      }
    },
  },
};
</script>
